import { sanitizeDecimalInput } from './decimalInput';

const CURRENCY_FORMATTER = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

/** Allows formatted values such as `$1,234.56` to round-trip on focus. */
export const parseCurrency = (raw: string): number => {
  const parsed = Number(sanitizeDecimalInput(raw));

  return Number.isNaN(parsed) ? 0 : parsed;
};

export const formatCurrency = (value: number): string => CURRENCY_FORMATTER.format(value);

const AMOUNT_FORMATTER = new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

/** For fields that already carry a `$` affix, where `formatCurrency` would stack a second symbol. */
export const formatAmount = (value: number): string => AMOUNT_FORMATTER.format(value);

/** Avoid floating-point rounding errors in money comparisons and divisions. */
export const toCents = (value: number): number => Math.round(value * 100);
